<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      class="createDeliveryBillDialog"
      title="创建送货单"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form ref="form" :model="form" :rules="ruleValidate" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="供应商编码">
            <el-input v-model="form.supplierNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商名称">
            <el-input v-model="form.supplierName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="直发标识">
            <el-select v-model="form.straightMark" :disabled="!straightAuth" clearable>
              <el-option
                  v-for="item in straightMarkList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="允许送货时间">
            <el-input value="16:00前" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="预计到货日期">
            <div class="clock">
              <el-date-picker
                  v-model="form.plannedArrivalTime"
                  value-format="yyyy-MM-dd 00:00:00"
                  style="width: 100%"
                  type="date"
                  placeholder="到达新时达的日期"/>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="送货单地址">
            <el-input v-model="form.purchaseReceiveAddress" placeholder="请输入送货单地址"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input v-model="form.note" placeholder="请输入备注"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联发货单号">
            <el-input v-model="form.deliveryNo" placeholder="请输入备库直发关联发货单号"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button type="primary" style="margin-bottom: 10px" @click="$refs.purchaseSelect.open()">新增</el-button>
    <el-table :data="form.receiveDetails" border>
      <!-- <el-table-column prop="sapsaleOrderDetailRowIndex" align="center" label="销售订单行项目" width="120"/> -->
      <el-table-column
          prop="evaluate"
          align="center"
          label="采购订单"
          show-overflow-tooltip
          width="100"/>
      <el-table-column prop="podetailRowNO" align="center" label="行号" width="80"/>
      <el-table-column prop="pCorderNo" align="center" label="出厂编号" width="120"/>
      <el-table-column
          prop="sapmaterialNO"
          align="center"
          label="物料编号"
          show-overflow-tooltip
          width="120"/>
      <el-table-column
          prop="sapmaterialName"
          align="left"
          label="物料描述"
          min-width="120"
          show-overflow-tooltip/>
      <el-table-column prop="responseDeliveryTime" align="center" label="交货期" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.responseDeliveryTime ? scope.row.responseDeliveryTime.substring(0, 10) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sumQuantity" align="center" label="采购数量" width="70"/>
      <el-table-column prop="receiveHasInStorageQty" align="center" label="已送数量" width="70"/>
      <el-table-column prop="quantity" align="center" label="本次送货数量" width="100">
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.quantity" placeholder="请输入" @input="checkQuantity(scope.row)"/>
        </template>
      </el-table-column>
      <el-table-column prop="location" align="center" label="仓位" width="150"/>
      <el-table-column prop="note" align="center" label="备注" width="150"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          fixed="right"
          width="80">
        <template slot-scope="scope">
          <el-button type="danger" @click="deleteRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
        v-if="pkid > 0"
        style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
      订单附件
    </div>
    <div v-if="pkid > 0">
      <el-upload
          action=""
          :http-request="submitUpload"
          :file-list="files"
          :show-file-list="false"
          style="float: left; margin-right: 5px">
        <el-button :v-loading="uploadLoading" type="primary" style="margin-bottom: 10px"> 添加附件</el-button>
      </el-upload>
    </div>
    <el-table v-if="pkid > 0" :data="form.accessoryList" border>
      <el-table-column type="index" align="center" label="#" width="55"/>
      <el-table-column prop="accessoryName" align="left" label="附件描述" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.accessoryName"
              class="tabInput"
              style="width: 400px; margin: 0 auto; text-align: center"/>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px" align="center">
        <template slot-scope="scope">
          <!-- <el-button type="danger" @click="oneDelete(scope.$index)"> 删除</el-button> -->
          <el-button type="primary" @click="download(scope.row)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="saveHandle">保存</el-button>
    </span>
    <purchaseSelect ref="purchaseSelect" @select="purchaseSelect"/>
  </el-dialog>
</template>

<script>
  import purchaseSelect from "./PurchaseSelect";
  import loginUtil from "@/util/loginUtil";

  export default {
    components: {purchaseSelect},
    data() {
      return {
        pkid: "",
        activeName: "deliverySlipInfo", // 当前标签页
        dialogVisible: false,
        uploadLoading: false,
        straightAuth:this.$auth(284),
        form: {
          pkid: "",
          supplierNo: "", // 供应商编码
          supplierName: "", // 供应商名称
          factoryName: "", // 工厂
          deliveryAddress: "", // 收货地址
          purchaseReceiveAddress: "",//送货单地址
          shipper: "", // 发货人
          straightMark: "",
          shipperPhone: "", // 发货人联系方式
          deliveryMethod: "", // 送货方式
          plannedArrivalTime: "", // 预计发货日期
          deliveryDate: "", // 预计到货日期
          note: "", // 备注
          receiveDetails: [], // 送货单明细
          accessoryList: [],
          deliveryNo:"",//备库直发关联发货单号
        },
        files: [],
        fileList: [],
        actionUrl: window.config.basicServerHttpUrl + "purchaseReceives/uploadReceipt",
        submitLoading: false,
        straightMarkList: [
          {label:"按单直发工地",value:"Z001"},
          {label:"备库直发工地",value:"Z002"},
          {label:"发新时达",value:"1000"},
        ],
        ruleValidate: {
          plannedArrivalTime: {required: true, message: "请选择预计到货日期"},
        },
      };
    },
    methods: {
      open(pkid, selection) {
        this.dialogVisible = true;
        this.pkid = pkid;
        if (pkid) {
          this.getData();
        } else {
          let newArr = [];
          selection.forEach((item) => {
            const obj = {
              evaluate: item.evaluate,
              podetailRowNO: item.rowNum,
              sapmaterialNO: item.partNo,
              sapmaterialName: item.partNameSpec,
              responseDeliveryTime: item.responseDeliveryTime,
              sapsaleOrderDetailRowIndex: item.sapsaleOrderDetailRowIndex,
              sumQuantity: item.qty,
              quantity: item.qty - item.receiveHasInStorageQty,
              hasInStorageQty: item.hasInStorageQty,
              supplierNo: item.supplierNo,
              pCorderNo: item.pCorderNo,
              shippingAddress: item.shippingAddress,
              supplierName: item.supplierName,
              purchaseDetailId: item.pkid,
              purchaseOrderId: item.mastPKID,
              straightMark: item.straightMark,
              location: item.location,
              note: item.remark,
              receiveHasInStorageQty: item.receiveHasInStorageQty,
            };
            newArr.push(obj);
          });
          this.form.receiveDetails = newArr;
          this.form.supplierNo = newArr[0].supplierNo;
          this.form.supplierName = newArr[0].supplierName;
          this.form.straightMark = newArr[0].straightMark;
          if (this.form.straightMark !== "Z001") {
            this.form.purchaseReceiveAddress = "美裕路599号新时达电气股份有限公司";
          } else {
            this.CheckAddress();
          }
        }
      },

      //检测明细地址是否一致
      CheckAddress() {
        if (this.form.receiveDetails.length) {
          const addressListFalse = this.form.receiveDetails.filter((item) => item.shippingAddress !== this.form.receiveDetails[0].shippingAddress);
          const addressListTrue = this.form.receiveDetails.filter((item) => item.shippingAddress === this.form.receiveDetails[0].shippingAddress);
          const flag = this.form.receiveDetails.length / 2;
          const length = addressListFalse.length;
          if (0 < length && length < flag) {
            this.CheckAction(addressListFalse, addressListTrue);
          } else if (length >= flag) {
            this.CheckAction(addressListTrue, addressListFalse);
          } else {
            this.CheckAction("", this.form.receiveDetails);
          }
        } else {
          this.form.purchaseReceiveAddress = "";
        }
      },

      //地址检测处理
      CheckAction(messageList, infoList) {
        var message = "";
        if (messageList) {
          messageList.forEach((item) => {
            message += "采购单号:" + item.evaluate + "-物料号:" + item.sapmaterialNO + "-行项:" + item.podetailRowNO + "直发地址不一致！" + "<br/>";
          });
          this.form.purchaseReceiveAddress = "";
          this.$nextTick(() => {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: message,
              customClass: "messageBox",
              type: "error",
            });
          });
        }
        this.form.receiveDetails = infoList;
        this.form.purchaseReceiveAddress = this.form.receiveDetails[0].straightMark === "Z001" ? this.form.receiveDetails[0].shippingAddress : "美裕路599号新时达电气股份有限公司";
      },

      // 编辑查详情
      getData() {
        this.$http.get("basic", "purchaseReceives/getPurchaseReceiveById/" + this.pkid).then((resp) => {
          this.form.pkid = resp.pkid;
          this.form.plannedArrivalTime = resp.plannedArrivalTime;
          this.form.supplierNo = resp.supplierNo;
          this.form.supplierName = resp.supplierName;
          this.form.straightMark = resp.straightMark;
          this.form.receiveDetails = resp.receiveDetails;
          this.form.accessoryList = resp.accessoryList;
          this.form.purchaseReceiveAddress = resp.purchaseReceiveAddress;
          this.form.receiveDetails.forEach(s => {
            if (s.quantity === "" || s.quantity == null || s.quantity === 0) {
              s.quantity = s.sumQuantity - s.receiveHasInStorageQty;
            }
          });
        });
      },
      // 检测本次送货数量是否超出剩余发货数量
      checkQuantity(row) {
        const reg = /^[0-9]*[1-9][0-9]*$/;
        if (!reg.test(row.quantity)) {
          this.$confirm("请输入大于0的整数", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
        if (row.quantity > row.sumQuantity - row.receiveHasInStorageQty) {
          this.$confirm("送货数量超出剩余发货数量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          row.quantity = "";
        }
      },
      // 删除行项
      deleteRow(index) {
        this.form.receiveDetails.splice(index, 1);
        this.CheckAddress();
      },
      // 新增行项
      purchaseSelect(purchaselist) {
        console.log(purchaselist);
        console.log(this.form.receiveDetails);
        if (purchaselist) {
          var WrongEvaluateMessage = "";
          var WrongStraightMarkMessage = "";
          var WrongSupplierMessage = "";
          var WrrongAddressMessage = "";
          var WrongLocationMessage = "";
          var Message = "";
          for (let row of purchaselist) {
            const WrongEvaluate = this.form.receiveDetails.find((item) => item.evaluate === row.evaluate && item.podetailRowNO === row.rowNum);
            let straightMark = "";
            if (this.form.straightMark === "发新时达"){
              straightMark = "1000";
            }else if(this.form.straightMark === "按单直发工地"){
              straightMark = "Z001";
            }else if (this.form.straightMark === "备库直发工地"){
              straightMark = "Z002";
            }
            const WrongStraightMark = row.straightMark !== this.form.straightMark ? true : false;
            const WrongSupplier = this.form.receiveDetails.find((item) => item.supplierName !== row.supplierName);
            const WrongAddress = this.form.purchaseReceiveAddress !== row.shippingAddress;
            const WrongLocation = this.form.receiveDetails.find((item) => item.location !== row.location);
            if (WrongEvaluate || WrongStraightMark || WrongSupplier || WrongLocation) {
              if (WrongEvaluate) {
                WrongEvaluateMessage += "采购单号：" + row.evaluate + ",行号：" + row.rowNum + "已存在，请勿重复添加" + "<br/>";
              }
              if (WrongStraightMark) {
                WrongStraightMarkMessage += "采购单号：" + row.evaluate + ",行号：" + row.rowNum + "直发标识不一致，请重新选择" + "<br/>";
              }
              if (WrongSupplier) {
                WrongSupplierMessage += "采购单号：" + row.evaluate + ",行号：" + row.rowNum + "供应商不一致，请重新选择" + "<br/>";
              }
              if (WrongLocation) {
                WrongLocationMessage += "采购单号：" + row.evaluate + ",行号：" + row.rowNum + "仓位不一致，请重新选择" + "<br/>";
              }
            } else if (this.form.straightMark === "Z001" && WrongAddress) {
              WrrongAddressMessage += "采购单号：" + row.evaluate + ",行号：" + row.rowNum + "直发地址不一致,请重新选择" + "<br/>";
            } else {
              const obj = {
                evaluate: row.evaluate,
                podetailRowNO: row.rowNum,
                sapmaterialNO: row.partNo,
                sapmaterialName: row.partNameSpec,
                responseDeliveryTime: row.deliveryDate,
                sapsaleOrderDetailRowIndex: row.sapsaleOrderDetailRowIndex,
                sumQuantity: row.qty,
                quantity: row.qty - row.hasInStorageQty,
                hasInStorageQty: row.hasInStorageQty,
                supplierNo: row.supplierNo,
                pCorderNo: row.pCorderNo,
                shippingAddress: row.shippingAddress,
                supplierName: row.supplierName,
                purchaseDetailId: row.pkid,
                purchaseOrderId: row.mastPKID,
                straightMark: row.straightMark,
                location: row.location,
                note:row.note,
                receiveHasInStorageQty:row.receiveHasInStorageQty,
              };
              this.form.receiveDetails.push(obj);
            }
          }
          //拼接所有报错信息
          Message = WrongEvaluateMessage + WrongStraightMarkMessage + WrongSupplierMessage + WrrongAddressMessage + WrongLocationMessage;
          if (Message !== "") {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: Message,
              type: "error",
              showCancelButton: false,
            });
          }
        } else {
          this.$message.error("请勾选需要添加的行项！");
        }
      },

      oneDelete(index) {
        this.form.accessoryList.splice(index, 1);
      },

      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        var pkid = {
          pkid: this.pkid,
        };
        this.$http
          .post("basic", "purchaseReceives/uploadReceipt", formData, pkid)
          .then((res) => {
            if (res.success) {
              this.uploadLoading = false;
              this.$message.success("上传成功");
              this.getData();
            }
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },

      download(row) {
        let data = {
          name: row.accessoryName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          console.log(res);
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },

      // 保存
      saveHandle() {
        if (!this.form.plannedArrivalTime) {
          this.$confirm("请选择预计发货日期", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        const arr = this.form.receiveDetails.filter((item) => !item.quantity);
        if (arr.length) {
          this.$confirm("请输入本次送货数量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.submitLoading = true;
        if (!this.pkid) {
          let id = 0;
          this.$http
            .post("basic", "purchaseReceives/create", this.form)
            .then((res) => {
              id = res;
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$message.success("保存成功");
              this.$http.get("basic", `purchaseReceives/updateNo/${id}`);
            })
            .catch(() => {
              this.submitLoading = false;
            });
        } else {
          this.$http
            .post("basic", "purchaseReceives/update", this.form)
            .then(() => {
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$message.success("编辑成功");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      },
    },
  };
</script>

<style>
.createDeliveryBillDialog .el-dialog__body {
  padding: 10px 20px;
}

.createDeliveryBillDialog .el-tabs__header {
  margin: 0 0 10px;
}

.messageBox {
  z-index: 9999 !important;
}
</style>
